import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { episodes } from "@/mocks/episodes";

interface EpisodeSelectorProps {
  current: number;
}

export default function EpisodeSelector({ current }: EpisodeSelectorProps) {
  const [keyword, setKeyword] = useState("");

  const list = useMemo(() => {
    const sorted = [...episodes].sort((a, b) => a.number - b.number);
    if (!keyword.trim()) return sorted;
    const kw = keyword.trim();
    return sorted.filter((ep) => String(ep.number).includes(kw) || ep.title.includes(kw));
  }, [keyword]);

  return (
    <div className="rounded-lg bg-background-50 border border-background-200 p-4 md:p-5">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4">
        <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-list-check-2 text-primary-500"></i>
          选集播放（共 {episodes.length} 集）
        </h3>
        <div className="relative w-full sm:w-56">
          <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="输入集数或标题定位"
            className="w-full pl-9 pr-3 py-2 text-sm rounded-md bg-background-100 border border-background-300 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300"
          />
        </div>
      </div>

      {list.length === 0 ? (
        <p className="text-sm text-foreground-500 py-8 text-center">没有找到对应的集数，换个关键词试试。</p>
      ) : (
        <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-2">
          {list.map((ep) => {
            const isActive = ep.number === current;
            return (
              <Link
                key={ep.id}
                to={`/play/${ep.number}`}
                title={`善良的小姨子 第${ep.number}集 ${ep.title}`}
                className={`h-10 rounded-md flex items-center justify-center text-sm font-medium transition-colors cursor-pointer ${
                  isActive
                    ? "bg-accent-500 text-background-50"
                    : "bg-background-100 text-foreground-700 border border-background-200 hover:border-primary-300 hover:text-primary-600"
                }`}
              >
                {ep.number}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}